module.exports = __webpack_public_path__ + "assets/edit_blue-17ff55.svg";